import React from "react";

export default function HoursSelector({ value, setValue }) {
  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <>
      <input
        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
        id="time-range"
        type="text"
        value={value}
        onChange={handleInputChange}
        placeholder="HH-HH"
      />
    </>
  );
}
